import { axiosInstance } from '@/core/services';
import { GetSchedulingsForQuestionnaireDTO } from '@aphp-ema/common/scheduling/GetSchedulingsForQuestionnaireDTO';
import { CreateSchedulingsForQuestionnaireDTO } from '@aphp-ema/common/scheduling/CreateSchedulingsForQuestionnaireDTO';

const API_BASE_URL =
  (import.meta.env.VITE_API_URL as string) || 'http://localhost:3000/api';

export const getQuestionnaireScheduling = async (
  questionnaireId: string,
): Promise<GetSchedulingsForQuestionnaireDTO> => {
  if (!questionnaireId) {
    throw new Error('questionnaireId is required to fetch scheduling.');
  }

  const response = await axiosInstance.get(
    `${API_BASE_URL}/questionnaire-scheduling/${questionnaireId}`,
  );

  return response.data;
};

export const createQuestionnaireScheduling = async (
  data: CreateSchedulingsForQuestionnaireDTO,
): Promise<void> => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}/questionnaire-scheduling`,
    data,
  );

  return response.data;
};
